module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="p-login__header-logo">\r\n		<div class="p-login__header-logo-img"></div>\r\n	</div>\r\n';

}
return __p
}